import { extractDomain } from '@/utils/filters'
import { events, superIncrement, trackAndIncrement } from './utils'

export function trackResourceAccessed (resource, extraParams) {
  const params = {
    content_id: resource.id,
    added_on: resource.added_on,
    digger_id: resource.digger_id,
    name: resource.name,
    url: resource.url,
    domain: extractDomain(resource.url),
    content_types: resource.resource_type,
    tags: resource.tags,
    tags_count: resource.tags.length,
    extra_links_count: resource.extra_links.length,
    ...extraParams
  }
  trackAndIncrement(events.RESOURCE_ACCESS, params)
}

export function trackPage (name) {
  window.analytics.page(name)
  superIncrement(events.PAGE)
}

export function trackSignin (userId) {
  window.analytics.identify(userId)
  trackAndIncrement(events.USER_SIGNIN)
}

export function trackSearchSearched (extraParams) {
  const params = {
    ...extraParams
  }
  trackAndIncrement(events.SEARCH_SEARCHED, params)
}

export function trackLoadMore (extraParams) {
  const params = {
    ...extraParams
  }
  trackAndIncrement(events.LOAD_MORE, params)
}

export function trackTagClicked (extraParams) {
  const params = {
    ...extraParams
  }
  trackAndIncrement(events.TAG_CLICKED, params)
}

export function trackNewsletterSubscribed (extraParams) {
  const params = {
    ...extraParams
  }
  window.analytics.track(events.NEWSLETTER_SUBSCRIBED, params)
}
